<script setup>
import TrafficChart from "@/views/teacher/components/TrafficChart.vue";
import DefaultDoughnutChart from "@/views/teacher/components/DefaultDoughnutChart.vue";
import BarChart from "@/views/profile/components/BarChart.vue";
import OutlinedCounterCard from "@/views/profile/components/OutlinedCounterCard.vue";
</script>

<template>
  <div class="container-fluid p-2 p-lg-4">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header p-3">
            <h5 class="mb-2">Análisis de Cursos Educativos</h5>
            <p class="mb-0">
              Monitorea información clave sobre inscripciones, participación de estudiantes
              y ganancias.
            </p>
          </div>
          <div class="card-body p-3">
            <div class="row">
              <outlined-counter-card
                :duration="2500"
                prefix="$"
                :count="45200"
                title="Ingresos Totales"
              />
              <outlined-counter-card
                :count="1200"
                title="Total de Estudiantes"
              />
              <outlined-counter-card
                class="mt-4 mt-lg-0"
                prefix="$"
                :count="38"
                title="Precio Promedio del Curso"
              />
              <outlined-counter-card
                :duration="3000"
                class="mt-4 mt-lg-0"
                suffix="%"
                :count="65"
                title="Tasa de Finalización"
              />
            </div>
            <hr class="horizontal dark" />


            <div class="row">
              <div class="col-lg-7 col-md-12">
                <div class="card">
                  <div class="p-3 pb-0 card-header">
                    <h6 class="mb-0">Fuentes de Tráfico de Estudiantes</h6>
                    <div class="d-flex align-items-center">
                      <span class="badge badge-md badge-dot me-4">
                        <i class="bg-primary"></i>
                        <span class="text-xs text-dark">Búsqueda Orgánica</span>
                      </span>
                      <span class="badge badge-md badge-dot me-4">
                        <i class="bg-dark"></i>
                        <span class="text-xs text-dark">Referencias</span>
                      </span>
                      <span class="badge badge-md badge-dot me-4">
                        <i class="bg-info"></i>
                        <span class="text-xs text-dark">Redes Sociales</span>
                      </span>
                    </div>
                  </div>
                  <div class="p-3 card-body">
                    <div class="chart">
                      <traffic-chart />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-2 mt-lg-0 col-lg-5 col-md-12 mt-lg-0">
                <default-doughnut-chart
                  title="Cursos Populares"
                  :chart="{
                    labels: ['Desarrollo Web', 'Ciencia de Datos', 'IA y ML', 'Diseño Gráfico', 'Negocios', 'Otros'],
                    datasets: [{ label: 'Inscripciones', data: [30, 10, 25, 15, 17, 3] }],
                  }"
                  :actions="{
                    route: 'https://example.com/cursos',
                    label: 'Ver Todos los Cursos',
                    color: 'secondary',
                  }"
                />
              </div>
            </div>

            <div class="mt-2 mt-lg-4 row">              
              </div>
              <div class="col-sm-12">
                <bar-chart
                  title="Ingresos por Curso"
                  :chart="{
                    labels: ['Desarrollo Web', 'Python para Ciencia de Datos', 'Aprendizaje Automático', 'Diseño UI/UX', 'Analítica de Negocios'],
                    datasets: [{
                      label: 'Ingresos',
                      backgroundColor: ['#2dce89', '#FF4767', '#344767', '#f4a261', '#e76f51'],
                      data: [15000, 12500, 10800, 8200, 9600]
                    }]
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
